<template>
  <div>
    <pass-validator :payload="registered_info_content"></pass-validator>
  </div>
</template>
<script>
import TextsHelper from '@/custom/classes/texts_helper.js'
import PassValidator from '@/components/PassValidator'
export default {
  name: 'completeness-indicator-form',
  props: ['payload'],
  data () {
    return {
      texts_helper: new TextsHelper(),
      registered_info_content: {}
    }
  },
  created () {
    this.$network_utils.getResourceTexts({
      current_type: this.payload.resource_type,
      current_resource_id: this.payload.resource_id
    }).then(texts => {
      let registered_info = this.texts_helper.getTextByDesignator(texts, 'registered_info')
      this.registered_info_content = JSON.parse(registered_info.content)
    })
  },
  components: {
    PassValidator
  }
}
</script>
